import openWindow from './open_window'
import { CustomsDeviceAuthorization } from './customs_authentication'
import { CustomsPopupAuthorization } from './customs_popup'

export async function outOfBandAuth ({ signupEnabled = true, usePopupAuthCodeFlow = false } = {}) {
  if (usePopupAuthCodeFlow) {
    const customsAuth = new CustomsPopupAuthorization()
    openWindow(customsAuth.loginUri, { features: ['resizable', 'scrollbars', 'status'] })
    await customsAuth.waitForSession()
    return true
  }

  const customsAuth = new CustomsDeviceAuthorization()
  await customsAuth.requestCode()
  openWindow(customsAuth.verificationUri, { features: ['resizable', 'scrollbars', 'status'] })
  await customsAuth.waitForToken()
  await customsAuth.buildSession()
  return true
}
